import { useTrainingSimulatorHome } from "@/lib/api/training-simulator/training-simulator.ts";
import { useCurrentUser } from "@/lib/api/user.ts";
import { PostHogEvents, useTrackPage } from "@/lib/posthog-events.ts";
import { Loader2 } from "lucide-react";
import { TrainingDevPanel } from "./dev/training-dev-panel.tsx";
import { TrainingHomeHeader } from "./training-home-header.tsx";
import { TrainingModuleCard } from "./training-module-card.tsx";
import { useTrainingExpandedModules } from "./use-training-expanded-modules.ts";

export function TrainingHome() {
  useTrackPage(PostHogEvents.PAGE_TRAINING);
  const { data: user } = useCurrentUser();
  const { data, isLoading, isError } = useTrainingSimulatorHome();

  const modules = data?.enrolled ? data.modules : [];
  const { isExpanded, toggle } = useTrainingExpandedModules(modules);

  if (isLoading) {
    return (
      <div className="flex min-h-screen w-full items-center justify-center bg-surfaces-z3">
        <Loader2 className="size-10 animate-spin text-text-secondary" />
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div className="flex min-h-screen w-full items-center justify-center bg-surfaces-z3">
        <p className="text-body-1 text-text-secondary">
          Something went wrong loading your training. Please try again.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-full bg-surfaces-z3">
      <div className="mx-auto flex w-full max-w-screen-2xl flex-col gap-10 px-6 py-10">
        <TrainingHomeHeader
          user={user}
          currentAttemptId={data.enrolled ? data.currentAttemptId : null}
          nextLevelId={data.enrolled ? data.nextLevelId : null}
        />

        {data.enrolled ? (
          <>
            <section className="flex flex-col gap-4 rounded-md bg-surfaces-z0 p-5">
              <h2 className="mb-4 text-header-4 text-text-primary">
                Your courses
              </h2>
              <div className="flex flex-col gap-4">
                {data.modules.map((module) => (
                  <TrainingModuleCard
                    key={module.id}
                    module={module}
                    isExpanded={isExpanded(module.id)}
                    onToggle={toggle}
                  />
                ))}
              </div>
            </section>

            {/*<TrainingPracticeSection />*/}
          </>
        ) : (
          <div className="flex min-h-72 flex-col items-center justify-center gap-2 rounded-2xl border border-surfaces-divider bg-surfaces-z2 p-10 text-center">
            <p className="text-header-4 text-text-primary">
              You&apos;re not enrolled in training yet
            </p>
            <p className="max-w-md text-body-1 text-text-secondary">
              Once your lead mentor enrolls you, your courses will appear here.
            </p>
          </div>
        )}
      </div>

      <TrainingDevPanel
        currentAttemptId={data.enrolled ? data.currentAttemptId : null}
      />
    </div>
  );
}
